import gql from 'graphql-tag';

export const insertOrganizationAcceptedTerms = gql`
mutation insertOrganizationAcceptedTerms($organization_id: uuid!, $terms_and_conditions_id: Int!) {
  insert_organization_accepted_terms_one(object: {terms_and_conditions_id: $terms_and_conditions_id, organization_id: $organization_id}) {
    id
  }
}
`;

export const setRequireTermsAcceptanceFlagToFalse = gql`
mutation setRequireTermsAcceptanceFlagToFalse($id: uuid!) {
  update_organization_by_pk(pk_columns: {id: $id}, _set: {requires_terms_acceptance: false}) {
    id
  }
}
`;

export const insertOrganizationContactAndOrganization = gql`
mutation insertOrganizationContactAndOrganization($objects: [organization_contact_insert_input!]!, $role: String!, $phone: String!, $userID: uuid!, $updated_at: timestamptz!) {
  insert_organization_contact(objects: $objects, on_conflict: {constraint: organization_contact_email_key, update_columns: [email]}) {
    returning {
      id
    }
  }
  update_user(where: {id: {_eq: $userID}}, _set: {role: $role, phone: $phone, updated_at: $updated_at}) {
    returning {
      id
    }
  }
}
`;

export const setTermsAndConditionsStatusToTrue = gql`
mutation setTermsAndConditionsStatusToTrue($userID: uuid!) {
  update_user_by_pk(pk_columns: {id: $userID}, _set: {terms_and_conditions_viewed: true}) {
    id
  }
}
`;

export const setTyCStatusToTrue = gql`
mutation setTyCStatusToTrue {
  update_user(where: {}, _set: {terms_and_conditions_viewed: true}) {
    affected_rows
  }
}
`;

export const termsAcceptedFromModal = gql`
mutation termsAcceptedFromModal($orgId: String!) {
  update_organization(where: {tax_id: {_eq: $orgId}}, _set: {requires_terms_acceptance: false, newProvider: false}) {
    returning {
      id
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/store/graphql/mutations/termsAndConditions.js